import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';

import { AuthConfigId } from '../../auth/auth.config';
import { SecurityService } from '../services/SecurityService';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        private oidcSecurityService: OidcSecurityService,
        private securityService: SecurityService,
    ) {}

    async canActivate(): Promise<boolean> {
        const authConfigId = this.securityService.getAuthConfigId();

        const authResult = await firstValueFrom(this.oidcSecurityService.checkAuth(undefined, authConfigId));

        if (!authResult.isAuthenticated) {
            if (!authResult.errorMessage) {
                await this.securityService.login(authConfigId);
            }
            return false;
        }

        this.redirectAfterAuthentication(authConfigId);
        return true;
    }

    private redirectAfterAuthentication(authConfigId: AuthConfigId) {
        this.oidcSecurityService.getState(authConfigId).subscribe((encodedRedirectionUrl) => {
            if (encodedRedirectionUrl) {
                this.removeRedirectionUrlFromState(authConfigId);
                try {
                    const url = atob(encodedRedirectionUrl);
                    if (url !== location.href) {
                        location.assign(url);
                    }
                } catch (e) {
                    console.error(encodedRedirectionUrl, e);
                }
            }
        });
    }

    private removeRedirectionUrlFromState(authConfigId: AuthConfigId) {
        this.oidcSecurityService.setState('', authConfigId).subscribe();
    }
}
